import { useAccount } from "wagmi";
import fetchLoansByLender from "../../services/fetchLoansByLender";
import { OfferType } from "./account/accountRows";
import { useDispatch } from "react-redux";
import { setModal } from "../../redux/counterSlice";
import AccountTable from "./account/accountTable";

// const LenderLoansTab = () => {
//   const router = useRouter();
//   const dispatch = useDispatch();
//   const { collection, id } = router.query;

//   const [page, setPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalOffers, setTotalOffers] = useState(0);

//   const [offers, setOffers] = useState<any[]>([]);
//   const [refresh, setRefresh] = useState(false);

//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const [loading, setLoading] = useState(true);

//   const { address, isConnected } = useAccount();

//   // const isOwner = (isConnected && address && data?.itemowner && data.itemowner.length > 0 && address === data.itemowner[0].owner)

//   useEffect(() => {
//     (async () => {
//       if (!isConnected || !address) return;
//       refreshOffers();
//     })();

//     return () => {};
//   }, [collection, id, page, address, isConnected, rowsPerPage]);

//   const refreshOffers = async () => {
//     try {
//       setLoading(true);
//       const res = await fetchLoansByLender({
//         limit: rowsPerPage,
//         page,
//         address: address,
//       });
//       setTotalOffers(res.totalCount);
//       setTotalPages(res.totalPages);
//       setOffers(res.results);
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const columns = [
//   //   {
//   //     id: "nft",
//   //     label: "NFT",
//   //     minWidth: 170,
//   //   },
//   //   {
//   //     id: "price",
//   //     label: "Price",
//   //     minWidth: 100,
//   //   },
//   //   {
//   //     id: "interestrate",
//   //     label: "Interest Rate",
//   //     minWidth: 115,
//   //   },
//   //   {
//   //     id: "date",
//   //     label: "Date",
//   //     minWidth: 100,
//   //   },
//   //   {
//   //     id: "duration",
//   //     label: "Duration",
//   //     minWidth: 100,
//   //   },
//   //   {
//   //     id: "expiration",
//   //     label: "Expiration",
//   //     minWidth: 100,
//   //   },
//   //   {
//   //     id: "to",
//   //     label: "To",
//   //     minWidth: 100,
//   //     // align: "center",
//   //   },
//   //   {
//   //     id: "actions",
//   //     label: "",
//   //     minWidth: 75,
//   //     // align: "center",
//   //   },
//   // ];
//   const columns = accountColumns({
//     interestRate: true,
//   });

//   const rows = offers?.map((offer) => {
//     const isOfferActive = !(
//       offer?.signingTime + offer?.expiration < Date.now() / 1000 ||
//       offer?.isExpired ||
//       offer?.status !== 0
//     );

//     return accountRow({
//       offer,
//       eventType: true,
//       action: (
//         <>
//           {isOfferActive && address !== offer.issuer && (
//             <button
//               onClick={() => {
//                 if (!isOfferActive) return;
//                 return dispatch(
//                   setModal({
//                     key: "RejectModal",
//                     data: {
//                       ...offer,
//                       refresh: () => setRefresh(true),
//                     },
//                   })
//                 );
//               }}
//               className={
//                 "mx-1 p-2 bg-jacarta-500 shadow-jacarta-500 hover:bg-red text-center font-semibold text-white transition-all rounded-md"
//               }
//             >
//               {isOfferActive && "Reject"}
//             </button>
//           )}
//         </>
//       ),
//     });
//   });

//   return (
//     <>
//       {/* <!-- Offers --> */}
//       <TableContainer className="scrollbar-custom">
//         <Table stickyHeader aria-label="sticky table">
//           <TableHead>
//             <TableRow>
//               {columns.map((column) => (
//                 <TableCell
//                   key={column.id}
//                   {...(column.align
//                     ? { align: column.align as TableCellProps["align"] }
//                     : {})}
//                   style={{ minWidth: column.minWidth }}
//                   classes={{
//                     root: "dark:bg-jacarta-500 bg-light-base dark:text-jacarta-100 text-jacarta-700",
//                   }}
//                 >
//                   {column.label}
//                 </TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {offers &&
//               offers.map((offer, index) => {
//                 return (
//                   <LenderLoansItem
//                     key={index}
//                     offer={offer}
//                     collection={collection}
//                     refreshOffers={refreshOffers}
//                   />
//                 );
//               })}
//             {!offers ||
//               (offers.length === 0 &&
//                 (loading ? (
//                   <div className="flex w-full justify-center items-center">
//                     <CircularProgress className="m-5" />
//                   </div>
//                 ) : (
//                   <NoRowsOverlay columnLength={columns.length} />
//                 )))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <TablePagination
//         classes={{
//           root: "dark:bg-jacarta-700 bg-light-base dark:text-jacarta-100 text-jacarta-700 flex flex-row-reverse",
//         }}
//         rowsPerPageOptions={[5, 10]}
//         component="div"
//         count={totalOffers || rowsPerPage * totalPages}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onPageChange={handleChangePage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//         backIconButtonProps={{
//           classes: {
//             root: `dark:bg-jacarta-700 bg-light-base dark:text-jacarta-100 text-jacarta-700 ${
//               !loading && (!rows.length || page === 0) ? "hidden" : ""
//             } ${loading ? "hidden" : ""}`,
//           },
//         }}
//         nextIconButtonProps={{
//           classes: {
//             root: `dark:bg-jacarta-700 bg-light-base dark:text-jacarta-100 text-jacarta-700 ${
//               !loading &&
//               (!rows.length ||
//                 rows.length < rowsPerPage ||
//                 page + 1 === totalPages) &&
//               "hidden"
//             } ${loading ? "hidden" : ""}`,
//           },
//         }}
//         labelRowsPerPage="Offers per page"
//       />
//     </>
//   );
// };

const LenderLoansTab = () => {
  const dispatch = useDispatch();
  const { address } = useAccount();

  const action = (offer: OfferType, refresh?: () => void) => {
    const showActions = !offer.isGlobal
      ? address === offer.issuer &&
        offer.status === 1 &&
        Number(offer.startTime) + Number(offer.duration) <
          Math.floor(Date.now() / 1000)
      : offer.filledGlobalLendOffers?.length > 0 &&
        offer.filledGlobalLendOffers?.some(
          (lendOffer) =>
            lendOffer.status === 1 &&
            lendOffer.issuer !== address &&
            Number(lendOffer.startTime) + Number(offer.duration) <
              Math.floor(Date.now() / 1000)
        ) &&
        offer.issuer === address;

    return (
      <>
        {showActions && (
          <button
            onClick={() => {
              return dispatch(
                setModal({
                  key: "LendingModal",
                  data: {
                    ...offer,
                    ...(refresh && { refresh }),
                    type: "liquidate",
                  },
                })
              );
            }}
            className={
              "mx-1 p-2 bg-jacarta-500 shadow-jacarta-500 hover:bg-red text-center font-semibold text-white transition-all rounded-md"
            }
          >
            Liquidate
          </button>
        )}
      </>
    );
  };

  return (
    <AccountTable
      fetcher={fetchLoansByLender}
      action={action}
      interestRate={true}
      to={true}
      collapsible={true}
    />
  );
};

export default LenderLoansTab;
